import { gql } from '@apollo/client'
import { PlanetLiteFragment } from '@src/graphql/fragment/planet'

export default gql`
  query GetMySeedPlanets {
    getMySeedPlanet {
      planets {
        ...PlanetLite
      }
    }
  }

  ${PlanetLiteFragment}
`
